import type { EditorEvents } from '@tiptap/react'
import { toast } from 'sonner'
import { reportWarning } from '#src/monitoring.ts'

export function handleTiptapContentError({
  editor,
  error,
  disableCollaboration,
}: EditorEvents['contentError']): void {
  // From https://tiptap.dev/docs/guides/invalid-schema#for-collaborative-editing

  // Disable collaboration to prevent syncing invalid content
  disableCollaboration()

  // Prevent emitting updates
  const emitUpdate = false

  // Disable further user input
  editor.setEditable(false, emitUpdate)

  toast.info(`Update needed to view content. Reloading…`, {
    duration: Infinity,
  })
  reportWarning(error.message)
  window.location.reload()
}
